var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.665039H6C6.7373 0.665039 7.33496 1.2627 7.33496 2V16C7.33496 16.7373 6.7373 17.335 6 17.335H2C1.2627 17.335 0.665039 16.7373 0.665039 16V2C0.665039 1.2627 1.2627 0.665039 2 0.665039Z",
    fill: "#4A81E6",
    stroke: "#4A81E6",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.665039H16C16.7373 0.665039 17.335 1.2627 17.335 2V6C17.335 6.7373 16.7373 7.33496 16 7.33496H12C11.2627 7.33496 10.665 6.7373 10.665 6V2C10.665 1.2627 11.2627 0.665039 12 0.665039Z",
    fill: "#4A81E6",
    stroke: "#4A81E6",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.665H16C16.7373 10.665 17.335 11.2627 17.335 12V16C17.335 16.7373 16.7373 17.335 16 17.335H12C11.2627 17.335 10.665 16.7373 10.665 16V12C10.665 11.2627 11.2627 10.665 12 10.665Z",
    fill: "#4A81E6",
    stroke: "#4A81E6",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFilled);
export default __webpack_public_path__ + "static/media/home_filled.ca67b3b87f513be56e79c01c72dcf188.svg";
export { ForwardRef as ReactComponent };